import { alpha } from "@mui/material";
export const MuiListItemButton = {
    styleOverrides: {
        root: ({ theme }) => ({
            borderRadius: "8px",
            "&:focus-visible": {
                backgroundColor: alpha(theme.palette.primary.main, 0.12)
            }
        })
    }
};
//# sourceMappingURL=ListItemButton.js.map